export default "__VITE_ASSET__p48P6XxH__"